import {
  Banner,
  Box,
  ModalBody,
  ModalFoot,
  Text,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { AnnouncementPicker } from 'components/shared/announcementPicker';
import { AdapterTypes } from 'components/shared/announcementPicker/adapters';

import { useMigrateOpeningHoursContext } from '../../migrateOpeningHours.context';

export function AudioMessage(): JSX.Element {
  const {
    announcement,
    setters: { setAnnouncement },
    onCancel,
    onNextStep,
  } = useMigrateOpeningHoursContext();

  const handleSelect = useCallback(
    (audioItem, type) => {
      ampli.businessHoursMigrationWizardAudioMessageAdded({ type });
      setAnnouncement(audioItem);
    },
    [setAnnouncement],
  );
  return (
    <>
      <ModalBody>
        <Text.Paragraph subdued variant="2">
          Set an audio message once, to ensure that it’s played in all phone
          flows that use this schedule now or in the future.
        </Text.Paragraph>
        <Box margin="400 0">
          <Banner
            icon="announcement"
            variant="announcement"
            description={
              <Text.Paragraph variant="4">
                Customers will hear this message when they call you outside of
                your business hours.
              </Text.Paragraph>
            }
          />
        </Box>
        <AnnouncementPicker
          adapter={AdapterTypes.Announcement}
          selectedAudio={announcement}
          fieldProps={{
            label: 'Standard audio message (outside business hours)',
          }}
          onSelect={handleSelect}
        />
      </ModalBody>
      <ModalFoot
        cancelOnClick={onCancel}
        confirmName="Continue to name"
        confirmProps={{ disabled: !announcement }}
        confirmOnClick={onNextStep}
      />
    </>
  );
}
